// extracted by mini-css-extract-plugin
export default {"root":"_2MiuP","left":"_3F0-R","right":"_2UNbb","author":"_3P6Ss","actions":"_2UFV_"};